<template>
    <main>
        <div class="main-image">
            <div class="title-1-container">
                <p class="title title1">
                    <span v-if="selectedLang() == 'en'">Who We Are</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">من نحن</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">ئێمە کێین</bdo></span>
                </p>
            </div>
            <div class="back-image">
                <div class="fade-layer"></div>
            </div>

            <div class="layer-container">
                <div class="layer">
                    <p class="title title2">
                        <span v-if="selectedLang() == 'en'">About Us</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">معلومات عنا</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">دەربارەی ئێمە</bdo></span>
                        <span
                            :class="{ 'red-line': selectedLang() == 'en', 'red-line-k': selectedLang() != 'en' }"></span>
                    </p>
                    <p>

                        <span v-if="selectedLang() == 'en'"> Kurdos Company was established in the year 2007 .
                            Headquartered
                            in Erbil Iraq. Kurdos Company offers
                            comprehensive soluions for the Healthcare</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">تأسست شركة كردوس عام ٧٠٠٢، ومقرها الرئيسي في
                                أربيل، العراق. تقدم شركة كردوس حلولاً شاملة لقطاع الرعاية الصحية.</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">کۆمپانیای کوردۆس لە ساڵی ٧٠٠٢ دامەزراوە .
                                بارەگاکەی لە هەولێر عێراقە. ئۆفەرەکانی کۆمپانیای کوردۆس
                                چارەسەری گشتگیر بۆ چاودێری تەندروستی</bdo></span>
                    </p>
                    <p>
                        <span v-if="selectedLang() == 'en'">Promoted by a team of competent professionals having more
                            than
                            25 years of experience
                            in various healthcare and logistics verticals, our vision is to create Kurdos Company into a
                            trusted
                            brand
                            that can provide total integrated solutions to customers in the changing business
                            environment.

                            At Kurdos, our mission is to develop new markets and products, expand business in all
                            intended
                            sectors,
                            and explore new opportunities in both global and domestic markets to sustain a targeted rate
                            of
                            growth in business.
                            All our products and services are aligned with our vision and mission.</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">يتولى فريق من المحترفين الأكفاء ذوي الخبرة
                                التي
                                تزيد عن ٥٢ عامًا في مختلف قطاعات الرعاية الصحية والخدمات اللوجستية، رؤيتنا هي أن نجعل من
                                شركة كوردوس علامة تجارية موثوقة، قادرة على تقديم حلول متكاملة وشاملة للعملاء في بيئة
                                الأعمال
                                المتغيرة.

                                في كوردوس، تتمثل مهمتنا في تطوير أسواق ومنتجات جديدة، وتوسيع نطاق أعمالنا في جميع
                                القطاعات
                                المستهدفة، واستكشاف فرص جديدة في الأسواق العالمية والمحلية للحفاظ على معدل نمو مستهدف في
                                الأعمال.

                                جميع منتجاتنا وخدماتنا تتوافق مع رؤيتنا ورسالتنا.</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">

                                لەلایەن تیمێکی پیشەیی لێهاتووەوە کە ئەزموونی
                                زیاتر لە ٥٢ ساڵیان هەیە، بەرەوپێش دەچێت
                                لە بواری جۆراوجۆری چاودێری تەندروستی و لۆجستیدا، دیدگامان دروستکردنی کۆمپانیای کوردۆسە
                                بۆ
                                کۆمپانیایەکی متمانەپێکراو
                                براند
                                کە دەتوانێت چارەسەری یەکگرتووی کۆی گشتی پێشکەش بە کڕیاران بکات لە گۆڕانی ژینگەی
                                بازرگانیدا.

                                لە کوردۆس ئەرکمان پەرەپێدانی بازاڕ و بەرهەمی نوێ، فراوانکردنی بازرگانییە بە هەموو
                                مەبەستێک
                                کەرتەکان،
                                و گەڕان بەدوای دەرفەتی نوێ لە هەردوو بازاڕی جیهانی و ناوخۆیی بۆ بەردەوامبوونی ڕێژەیەکی
                                ئامانجدار لە...
                                گەشەکردن لە بازرگانیدا.
                                هەموو بەرهەم و خزمەتگوزارییەکانمان لەگەڵ دید و ئەرکەکەماندا هاوتەریبن.</bdo></span>

                    </p>
                    <strong>
                        <span v-if="selectedLang() == 'en'">Kurdos Company along with our strategic pariners, currently
                            operates in the entire iraq
                            region.</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">تعمل شركة كوردوس، إلى جانب شركائها
                                الاستراتيجيين،
                                حاليًا في جميع أنحاء العراق.</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">کۆمپانیای کوردۆس هاوشانی پارینەرە
                                ستراتیژییەکانمان، لە ئێستادا لە تەواوی عێراق کاردەکات
                                هەرێم.</bdo></span>

                    </strong>
                    <div class="devider"></div>
                    <p class="title title3">
                        <span v-if="selectedLang() == 'en'">WHAT WE DO</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">ماذا نفعل</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">چی دەکەین </bdo></span>
                        <span
                            :class="{ 'red-line': selectedLang() == 'en', 'red-line-k': selectedLang() != 'en' }"></span>
                    </p>
                    <div class="links">
                        <router-link :to="{ name: 'wellness' }">
                            <p><span v-if="selectedLang() == 'en'">Kurdos Wellness</span>
                                <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">صحة</bdo></span>
                                <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەندروستی</bdo></span>
                            </p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#E43D34"
                                viewBox="0 0 256 256">
                                <path
                                    d="M200,64V168a8,8,0,0,1-16,0V83.31L69.66,197.66a8,8,0,0,1-11.32-11.32L172.69,72H88a8,8,0,0,1,0-16H192A8,8,0,0,1,200,64Z">
                                </path>
                            </svg>
                        </router-link>
                        <router-link :to="{ name: 'medtech' }">
                            <p>
                                <span v-if="selectedLang() == 'en'">Kurdos MedTech</span>
                                <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">التكنولوجيا الطبية</bdo></span>
                                <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەکنەلۆژیای پزیشکی</bdo></span>
                            </p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#E43D34"
                                viewBox="0 0 256 256">
                                <path
                                    d="M200,64V168a8,8,0,0,1-16,0V83.31L69.66,197.66a8,8,0,0,1-11.32-11.32L172.69,72H88a8,8,0,0,1,0-16H192A8,8,0,0,1,200,64Z">
                                </path>
                            </svg>
                        </router-link>
                        <router-link :to="{ name: 'infrastructure' }">
                            <p> <span v-if="selectedLang() == 'en'">Kurdos Infra</span>
                                <span v-if="selectedLang() == 'ar'"><bdo dir="rtl"> بنية کوردوس </bdo></span>
                                <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">ژێرخانی کوردۆس</bdo></span>
                            </p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#E43D34"
                                viewBox="0 0 256 256">
                                <path
                                    d="M200,64V168a8,8,0,0,1-16,0V83.31L69.66,197.66a8,8,0,0,1-11.32-11.32L172.69,72H88a8,8,0,0,1,0-16H192A8,8,0,0,1,200,64Z">
                                </path>
                            </svg>
                        </router-link>
                    </div>
                </div>
            </div>

        </div>
        <!-- <div class="extra-footer"></div> -->
    </main>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { selectedLang } from '../../utils/selected_lang';


</script>

<style scoped>
* {
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;

}

main {
    color: #073762 !important;
}

.dark main {
    color: #fff !important;
    background: #131313 !important;
}

.main-image {
    background-size: cover;
    background-position: center center;
    position: relative;
    margin-bottom: 50px;
}

.dark .main-image {
    background: #131313;
}

.back-image {
    background: url(/images/healthcare3.jpg);
    height: 100vh;
    overflow: hidden;
    width: 100%;
    position: absolute;
    top: 0;
    background-size: cover;
    border-bottom: 1px solid rgb(231, 231, 231);
}
.dark .back-image{
     border-bottom: 1px solid rgb(74, 74, 74);
}
.fade-layer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, #F6F8FB, transparent);
}

.dark .fade-layer {
    background: linear-gradient(to top, #131313, transparent)
}


.title {
    text-transform: uppercase;
    color: #073762 !important;
    position: relative
}


.title-1-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40vh;
}

.title-1-container .title1 {
    font-size: 50px;
    color: white;
    z-index: 1;
}

.extra-footer {
    height: 420px;
    background: #F6F8FB;
}

.layer-container {
    display: flex;
    justify-content: center;
}

.layer {

    width: 80%;
    background: white;
    position: relative;
    /* top: 80px; */
    z-index: 1;
    padding: 40px 50px;
    border-radius: 15px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
.dark .layer {
    background: #242424;
}


.title2,
.title3 {
    font-size: 35px !important;
    position: relative;
}

.title2 .red-line,
.title3 .red-line {
    position: absolute;
    width: 100px;
    height: 4px;
    background-color: #E43D34;
    border-radius: 10px;
    top: 50%;
    transform: translatex(20%);
}


.devider {
    width: 100%;
    height: 1px;
    background-color: rgb(222, 222, 222);
    margin: 30px 0;
}
.dark .devider {
    background-color: rgb(57, 57, 57);
}

.links {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.links a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    border: 1px solid rgb(232, 232, 232);
    padding: 20px;
    border-radius: 15px;
    gap: 10px;
    text-decoration: none;
    color: #073762 !important;
    text-transform: capitalize;
}
.dark .links a{
    border: 1px solid rgb(74, 74, 74);
}
.links a:hover {
    background: #E43D34;
    color: #fff !important;
}
.dark .links a{
    color: #fff !important;
}
.dark .title{
    color: #fff !important;
}
.links a svg {
    transition: all 0.1s ease-in-out;
}

.links a:hover svg {
    transform: translate(10px, -10px);
}

.links a p {
    margin: auto 0;
    font-weight: bold;
}

@media(max-width:900px) {
    .extra-footer {
        height: 330px;
    }
}

@media(max-width:768px) {
    .title1 {
        font-size: 40px;
        white-space: nowrap;
    }

    .title2,
    .title3 {
        font-size: 25px !important;
    }

    .title2::after {
        left: 50%;
    }

    .title3::after {
        left: 62%;
    }

    .extra-footer {
        height: 400px;
    }

    .links {
        flex-direction: column;
    }

    .layer {
        width: 90%;
        padding: 20px;
    }

}
</style>